<template>
  <div class="home container">
    <NewBoard />
    <!-- <transition name="fade" mode="in-out">
      <button class="load-archived" @click="loadArchived" v-if="true">Load archived</button>
    </transition>-->
    <div>
      <button v-if="boards.length === 0" @click="loadBoards">Load boards</button>
    </div>
    <transition name="fade" mode="in-out">
      <button class="load-shared" @click="loadShared" v-if="sharedBoards.length < 1">Load shared</button>
    </transition>
    <transition name="fade" mode="in-out">
      <Boards :boards="boards" :sharedBoards="sharedBoards" />
    </transition>
    <button class="go-archived" @click="goArchived">See archived projects</button>
  </div>
</template>

<script>
import db from "@/fb/init";
import { EventBus } from "@/eventbus";

import NewBoard from "@/components/NewBoard";
import Boards from "@/components/Boards";

export default {
  name: "home",
  props: ["user", "currentUser"],
  data() {
    return {
      userId: null,
      boards: [],
      sharedBoards: []
    };
  },
  components: { NewBoard, Boards },
  beforeMount() {
    this.userId = sessionStorage.getItem("userId");
  },
  watch: {
    sharedBoards() {
      if (this.sharedBoards.length > 0) {
        window.sessionStorage.setItem("loadedShared", true);
      }
    }
  },
  mounted() {
    this.loadBoards();

    if (window.sessionStorage.getItem("loadedShared")) {
      this.loadShared();
    }

    EventBus.$on("deleteBoard", board => {
      db.collection("boards")
        .doc(board.board_id)
        .collection("lists")
        .get()
        .then(snap => {
          snap.docs.forEach(doc => {
            db.collection("boards")
              .doc(board.board_id)
              .collection("lists")
              .doc(doc.id)
              .delete();
          });
        })
        .then(() => {
          db.collection("boards")
            .doc(board.board_id)
            .delete()
            .then(() => {
              this.boards = this.boards.filter(b => {
                return b.board_id !== board.board_id;
              });
              this.$router.push("/");
            })
            .catch(err => {
              const messageObj = {
                message: err.message,
                status: "error",
                duration: 3000
              };
              EventBus.$emit("showFlash", messageObj);
            });
        })
        .catch(err => {
          const messageObj = {
            message: err.message,
            status: "error",
            duration: 3000
          };
          EventBus.$emit("showFlash", messageObj);
        });
    });

    EventBus.$on("createBoard", board => {
      db.collection("boards")
        .doc(board.board_id)
        .set(board)
        .catch(err => {
          window.console.log("err.message", err.message);
          const messageObj = {
            message: err.message,
            status: "error",
            duration: 3000
          };
          EventBus.$emit("showFlash", messageObj);
        });
    });
  },
  methods: {
    loadShared() {
      db.collection("boards")
        .where("sharedUsers", "array-contains", this.currentUser)
        .orderBy("name")
        .onSnapshot(snapshot => {
          snapshot.docChanges().forEach(change => {
            if (change.type === "added") {
              this.sharedBoards.push({ ...change.doc.data() });
            }
            if (change.type === "modified") {
              this.sharedBoards.forEach(b => {
                if (b.board_id === change.doc.id) {
                  b = change.doc.data();
                }
              });
            }
            if (change.type === "removed") {
              this.sharedBoards = this.sharedBoards.filter(
                b => b.board_id !== change.doc.id
              );
            }
          });
        });
    },
    goArchived() {
      this.$router.push("/archived");
    },
    loadBoards() {
      db.collection("boards")
        .where("userId", "==", this.userId)
        .where("archived", "==", false)
        .orderBy("name")
        .onSnapshot(snapshot => {
          snapshot.docChanges().forEach(change => {
            if (change.type === "added") {
              this.boards.push({ ...change.doc.data() });
            }
            if (change.type === "modified") {
              this.boards.forEach(b => {
                if (b.board_id === change.doc.id) {
                  b = change.doc.data();
                }
              });
            }
            if (change.type === "removed") {
              this.boards = this.boards.filter(
                b => b.board_id !== change.doc.id
              );
            }
          });
        });
    },
    loadArchived() {}
  }
};
</script>
